import { OrbState } from "@/components/ui/orb-state";

export function PageLoader({ message = "Loading..." }: { message?: string }) {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center space-y-4">
        <OrbState state="working" size="full" label={message} />
        <p className="text-sm text-muted-foreground" aria-hidden="true">{message}</p>
      </div>
    </div>
  );
}
